/* About Us HH — simple fade-in observer */
(function(){
  'use strict';
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.hh-about [data-animate]').forEach(el => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

  function init() {
    document.querySelectorAll('.hh-about [data-animate]').forEach(el => io.observe(el));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
